// Reselect is not a dependency of this repo (see src/pages/PlannerPage/scheduler/adapter.js).
// This is a minimal, hand-rolled stand-in for reselect's `createSelector`, keyed on reference
// equality of each input selector's output.
//
// A single-entry cache is NOT safe here: several components can call the same module-level
// selector with different arguments in the same render pass (e.g. two board tiles each calling
// `getSortedAssignees(state, ownAssignees)`). A single-entry cache thrashes between them - every
// call evicts the previous caller's entry, so on the next store notification react-redux
// re-evaluates a stale caller's selector against a cache still holding someone else's inputs,
// gets a freshly-recomputed (different-reference) result, and re-renders even though nothing that
// caller reads actually changed. Keep a small ring of recent entries instead, matching whichever
// one's inputs still line up.
const CACHE_SIZE = 10;

export const memoizeSelector = (inputSelectors, resultFn) => {
  const cache = [];

  return (...args) => {
    const inputs = inputSelectors.map((selector) => selector(...args));

    const cached = cache.find(
      (entry) =>
        entry.inputs.length === inputs.length &&
        entry.inputs.every((value, index) => value === inputs[index])
    );

    if (cached) {
      return cached.result;
    }

    const result = resultFn(...inputs);
    cache.unshift({ inputs, result });
    if (cache.length > CACHE_SIZE) {
      cache.pop();
    }

    return result;
  };
};
